import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-container',
  template: `
    <main class="background">
      <section
        class="container flex flex-col items-center justify-center w-full h-full py-16 mx-auto"
      >
        <ng-content />
      </section>
    </main>
  `,
  styleUrls: ['./auth-container.component.scss'],
})
export class AuthContainer {}
